import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';

export function useAroIdMeEnabled() {
  const [aroIdMeEnabled, setAroIdMeEnabled] = useState(false);
  const flagsContext = useFeatureFlagsValue();

  useEffect(() => {
    const enabled =
      flagsContext?.flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_ARO_ID_ME?.toString())?.flagValue ?? false;
    setAroIdMeEnabled(enabled);
  }, [flagsContext]);

  return { aroIdMeEnabled };
}
